export const isEmailValid = (value: string) =>
  /^[=_0-9a-z+~\'!$&*^`|#%/?{}-]+(\.[=_0-9a-z+~\'!$&*^`|#%/?{}-]+)*@(([-0-9a-z_]+\.)+)([a-z0-9-]{2,20})$/.test(value);
